import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { resetPassword } from "../../api/userAuth";
import { useNotify } from "../../context/NotifyContext";
import AuthShell from "../../components/auth/AuthShell";
import { AuthField, AuthPasswordInput } from "../../components/auth/AuthField";

const NewPassword = () => {
  const { notify } = useNotify();
  const navigate = useNavigate();
  const location = useLocation();
  const { username, resetToken } = location.state || {};

  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleResetPassword = async () => {
    if (!username) return notify("User not found", "error");
    if (!newPassword || !confirmPassword)
      return notify("Password & Confirm Password are required", "warning");
    if (newPassword !== confirmPassword)
      return notify("Password & Confirm Password do not match", "warning");
    if (!resetToken) return notify("Unauthorized action", "error");
    if (newPassword.length < 6)
      return notify("Password must be at least 6 characters", "warning");

    try {
      setLoading(true);
      const res = await resetPassword({
        userName: username,
        newPassword,
        resetToken,
      });

      if (!res.success)
        return notify(res.message || "Failed to reset password", "error");

      notify(res.message || "Password reset successfully", "success");
      navigate(`/verify/mpin/${username}`);
    } catch (err) {
      notify(err.message || "Something went wrong", "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell
      eyebrow="Secure your account"
      title="Set New Password"
      subtitle="Choose a strong password to continue."
      footer={
        <button type="button" className="ds-auth-link" onClick={() => navigate("/login")}>
          Go to Login Page
        </button>
      }
    >
      <div className="flex flex-col gap-3.5">
        <AuthField label="Username">
          <input className="ds-input" value={username || ""} disabled />
        </AuthField>

        <AuthField label="New Password" required>
          <AuthPasswordInput
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            show={showNewPassword}
            onToggle={() => setShowNewPassword((v) => !v)}
          />
        </AuthField>

        <AuthField label="Confirm Password" required>
          <AuthPasswordInput
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            show={showConfirmPassword}
            onToggle={() => setShowConfirmPassword((v) => !v)}
          />
        </AuthField>

        <button
          type="button"
          onClick={handleResetPassword}
          disabled={loading}
          className="ds-btn ds-btn-primary ds-btn-block"
        >
          {loading ? "Processing..." : "Reset Password"}
        </button>
      </div>
    </AuthShell>
  );
};

export default NewPassword;
